module.exports = {"620724100":"城关镇","620724101":"宣化镇","620724102":"南华镇","620724103":"巷道镇","620724104":"合黎镇","620724105":"骆驼城镇","620724106":"新坝镇","620724107":"黑泉镇","620724108":"罗城镇","620724400":"甘肃高台工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620724.json
// module id = 2922
// module chunks = 0